<article class="section-inset-b mt-4 initiative-detail" *ngIf="initiative$ | async as initiative">
  <div class="container">
    <div class="row section-inset-b">
      <div class="col-md-6 col-xl-7 pt-2">
        <app-breadcrumbs class="d-block mb-5" *ngIf="breadcrumbs$ | async as crumbs" [breadcrumbs]="crumbs"></app-breadcrumbs>
        <main class="text-max-width-md-sm">
          <div class="publish-alert alert alert--info d-flex align-items-center" *ngIf="!initiative.publish">
            <div class="me-3">
              <app-icon anchor="icon-warning"></app-icon>
            </div>
            <span [innerHTML]="previewPlaceholder$ | async"></span>
          </div>
          <ng-container *ngIf="initiative.createdById === (user$ | async)?.id || (user$ | async | requiredRole : ['Administrator'])">
            <section class="card mb-3 mt-3 mt-md-4 mb-md-5 initiative-detail__edit">
              <h2 class="h6 text-primary fw-bold type-body-md font-secondary mb-4">Je bent eigenaar van dit initatief</h2>
              <a [routerLink]="['bewerken']" class="button button--tertiary">
                <span>{{ 'initiatief-bewerk-knop-label' | fromDictionary }}</span>
                <app-icon anchor="icon-edit"></app-icon>
              </a>
            </section>
          </ng-container>

          <strong class="text-primary text-max-width-xs mb-1 d-block lh-sm type-body-md" *ngIf="initiative.subtitle">
            {{ initiative.subtitle }}
          </strong>
          <h1 class="h2 text-secondary text-max-width-xs mt-2">{{ initiative.title }}</h1>
          <section class="mb-3 mt-4" *ngIf="initiative?.themes?.length || initiative.locations?.length">
            <ul class="meta-list">
              <li *ngFor="let theme of initiative.themes; let i = index">
                <a [routerLink]="['/thema', theme.slug]" class="button button-icon button--primary">
                  <app-icon class="icon-xs" [anchor]="theme.icon || 'icon-idea'" [attr.aria-label]="theme.title"></app-icon>
                </a>
              </li>
              <li class="me-3">
                <ng-container *ngIf="initiative.locations?.length === 1">
                  <a
                    class="d-inline-flex align-items-center"
                    [href]="
                      initiative.entireArea
                        ? 'https://www.google.com/maps/place/IJssel/@52.2733711,5.6986093'
                        : 'https://www.google.com/maps/search/' + initiative.locations?.[0]?.lat + ',' + initiative.locations?.[0]?.lng
                    "
                    aria-label="bekijk locatie op google maps"
                    target="_blank"
                  >
                    <span class="chip chip--muted">
                      <app-icon anchor="icon-map-marker"></app-icon>
                    </span>
                    <span class="text-primary fw-bold ms-2">
                      <ng-container *ngIf="!initiative.entireArea">
                        {{ initiative.locations?.[0]?.label || ('bekijk-op-kaart' | fromDictionary) }}
                      </ng-container>
                      <ng-container *ngIf="initiative.entireArea">{{ 'gehele-ijssel' | fromDictionary }}</ng-container>
                    </span>
                  </a>
                </ng-container>
                <a
                  *ngIf="(initiative.locations?.length || 0) > 1"
                  class="d-inline-flex align-items-center"
                  [routerLink]="['.']"
                  fragment="praktische-informatie"
                >
                  <span class="chip chip--muted">
                    <app-icon anchor="icon-map-marker"></app-icon>
                  </span>
                  <span class="text-primary fw-bold ms-2">{{ 'bekijk-locaties' | fromDictionary }}</span>
                </a>
              </li>
            </ul>
          </section>
          <figure
            class="mt-4 mb-3 d-block d-md-none initiative-detail__figure initiative-detail__figure--mobile"
            *ngIf="initiative.image && initiative.image.url"
          >
            <div class="initiative-detail__figure__wrapper">
              <app-image
                [imageSizes]="[300, 500, 800]"
                [width]="700"
                [height]="500"
                [loading]="'eager'"
                [alt]="initiative.image.alt ?? initiative.title"
                [image]="initiative.image"
                [sizes]="{ xs: 12, md: 6 }"
              ></app-image>
              <app-bg-wave [autoPlay]="false" [startPos]="'20s'" [bgColor]="'var(--bs-light)'" [strokeColor]="'transparent'"></app-bg-wave>
            </div>
            <figcaption *ngIf="initiative.image.caption" class="mt-4 type-body-xs text-primary">
              &copy; {{ ('foto-credits-prefix' | fromDictionary) + initiative.image.caption }}
            </figcaption>
          </figure>

          <div class="text-max-width-xxs mx-auto mx-md-0">
            <p class="lead fw-bold py-3 py-xl-4" *ngIf="initiative.intro">
              {{ initiative.intro }}
            </p>
          </div>
        </main>
      </div>
      <aside class="col-md-6 col-xl-5">
        <figure class="mb-6 d-none d-md-block initiative-detail__figure" *ngIf="initiative.image && initiative.image.url">
          <div class="pull-e initiative-detail__figure__wrapper">
            <app-image
              [imageSizes]="[900, 1400, 1800]"
              [alt]="initiative.image.alt ?? initiative.title"
              [image]="initiative.image"
              [sizes]="{ xs: 12, md: 6 }"
              [objectFitMode]="true"
            ></app-image>
            <app-bg-wave
              [autoPlay]="false"
              [startPos]="'12s'"
              [bgColor]="'var(--bs-light)'"
              [strokeColor]="'var(--bs-secondary)'"
            ></app-bg-wave>
          </div>
          <figcaption *ngIf="initiative.image.caption" class="mt-4 type-body-xs initiative-detail__figure__caption text-primary">
            &copy; {{ ('foto-credits-prefix' | fromDictionary) + initiative.image.caption }}
          </figcaption>
        </figure>
      </aside>

      <div class="row align-items-center justify-content-center section-inset-y" *ngIf="(hasRelated$ | async) === true">
        <ng-container *ngIf="relatedEvents$ | async as events">
          <ng-container *ngIf="events[0] as latestEvent">
            <app-event-teaser-card
              [title]="latestEvent.title"
              [linkToContent]="latestEvent.url"
              [subtitle]="latestEvent.title"
              [comingSoonText]="'evenement-binnenkort-tekst' | fromDictionary"
              [linkText]="'evenement-teaser-link-tekst' | fromDictionary"
              [date]="latestEvent.start || ''"
              class="col-md-6"
            ></app-event-teaser-card>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="relatedStories$ | async as stories">
          <ng-container *ngIf="stories[0] as latestStory">
            <app-teaser-card
              [title]="latestStory.title"
              [subtitle]="latestStory.intro"
              [image]="latestStory.image"
              [linkToContent]="latestStory.url"
              [linkText]="'initiatief-detail-teaser-link-tekst' | fromDictionary"
              class="col-md-6"
            ></app-teaser-card>
          </ng-container>
        </ng-container>
      </div>

      <div class="container container-size-xs">
        <!--<div
          class="markdown-content mt-5"
          fstrDynamicContent
          [innerHTML]="initiative?.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined | safe"
        ></div>-->

        <ngx-dynamic-hooks
          class="markdown-content mt-5"
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="initiative?.text || '' | resizeHtmlImages | stripEmbed : (cookiePreferences$ | async) ?? undefined"
          fstrDynamicContent
        ></ngx-dynamic-hooks>

        <app-content-meta-info
          *ngIf="initiative.locations?.length"
          [locations]="initiative.locations || []"
          class="d-block my-4"
          [entireArea]="initiative.entireArea ?? false"
        ></app-content-meta-info>
      </div>
    </div>
    <div class="section-inset-y" *ngIf="initiative.showContactOnPlatform">
      <app-contact-card
        [contact]="initiative.contact"
        [name]="initiative?.contact?.name || null"
        [label]="initiative?.contact?.image?.caption ?? null"
        [email]="initiative?.contact?.email || null"
        [imageUrl]="initiative?.contact?.image?.url ?? null"
        [logoUrl]="initiative?.contact?.logo?.url ?? null"
        [title]="'initiatief-contact-card-titel' | fromDictionary"
        [subtitle]="'initiatief-contact-card-tekst' | fromDictionary"
      ></app-contact-card>
    </div>
  </div>

  <div class="overflow-hidden" *ngIf="(relatedContent$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedContent$ | async as relatedContent">
      <app-related-content
        [title]="'gerelateerde-content-titel' | fromDictionary"
        [subtitle]="initiative.title"
        [content]="relatedContent"
        *ngIf="relatedContent.length"
      ></app-related-content>
    </div>
  </div>

  <ng-container *ngIf="(relatedStories$ | async)?.length">
    <div class="initiative__related-stories overflow-hidden pb-md-5" *ngIf="relatedStories$ | async as stories">
      <app-bg-wave [autoPlay]="false"></app-bg-wave>
      <div class="initiative__related-stories__wrapper bg-secondary py-5">
        <app-related-stories
          class="container d-block section-inset-t"
          [stories]="stories"
          [title]="initiative.title"
          *ngIf="stories.length"
        ></app-related-stories>
      </div>
      <app-bg-wave class="bg--end" [strokeColor]="'transparent'" [autoPlay]="false"></app-bg-wave>
    </div>
  </ng-container>

  <div class="overflow-hidden" *ngIf="(relatedEvents$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedEvents$ | async as relatedEvents">
      <app-related-events
        [compact]="false"
        [title]="'initiatief-carousel-evenement-titel' | fromDictionary"
        [subtitle]="initiative.title"
        [events]="relatedEvents"
        *ngIf="relatedEvents.length"
      ></app-related-events>
    </div>
  </div>

  <div class="section-outset-y">
    <div class="container">
      <app-vote
        [title]="'initiatief-stemmen-titel' | fromDictionary : false"
        [text]="'initiatief-stemmen-tekst' | fromDictionary : false"
        [resultText]="'initiatief-stemmen-resultaat-tekst' | fromDictionary : false"
        [voteCount]="(likes$ | async) ?? 0"
        [isVoted]="(liked$ | async) ?? false"
        (vote)="like(initiative.id)"
      ></app-vote>
    </div>
  </div>

  <div class="overflow-hidden" *ngIf="(relatedInitiatives$ | async)?.length">
    <div class="container my-md-5" *ngIf="relatedInitiatives$ | async as relatedInitiatives">
      <app-related-initiatives [initiatives]="relatedInitiatives" *ngIf="relatedInitiatives.length"></app-related-initiatives>
    </div>
  </div>
</article>
